export default __webpack_public_path__ + "static/media/sideMenuCheck.8781f584.svg";